import React, { useState } from "react";
import {
  ListGroup,
  ListGroupItem,
  ListGroupItemHeading,
  Button,
} from "reactstrap";
import PlaylistView from "./PlaylistView";
import {
  PlaylistModel,
  EventProps,
  getMusicServiceName,
} from "./EventModel";
import SongsSelected from "./SongsSelected";
import BackButton from "./BackButton";
import ForwardIcon from "./ForwardIcon";
import ActionsWrapper from "./ActionsWrapper";
import { Link } from "react-router-dom";
import useAPI from "./useAPI";
import { EventModel } from "./EventModel";

const EventPlaylists: React.FC<EventProps> = (props) => {
  const [playlistId, setPlaylistId] = useState<string | undefined>();

  useAPI<EventModel>(
    `api/events/${props.event.id}/playlists/update`,
    { method: "PUT" },
    props.onEventUpdated,
    props.onError
  );

  const getSelectedPlaylist = (): PlaylistModel | undefined => {
    return props.event.playlists.find((p) => p.id === playlistId);
  };

  const nextPlaylist = (): void => {
    const playlist = getSelectedPlaylist();
    if (playlist) {
      const i = props.event.playlists.indexOf(playlist);
      const n = i < props.event.playlists.length - 1 ? i + 1 : 0;
      const nextPlaylist = props.event.playlists[n];
      setPlaylistId(nextPlaylist.id);
    }
  };

  const playlist = getSelectedPlaylist();
  return !playlist ? (
    <React.Fragment>
      <BackButton tag={Link} to={"/edit/" + props.event.id} />
      <h1>Event Music</h1>
      <p>
        Select a theme below or open your&nbsp;
        {getMusicServiceName(props.event.musicService)} app to start&nbsp;
        playing songs. We recommend shuffling each playlist. Return to mixopia&nbsp;
        to finish the event and share playlists.
      </p>
      <ListGroup>
        <h2>Playlists</h2>
        {props.event.playlists.map((p) => (
          <ListGroupItem
            action
            tag={Button}
            key={p.id}
            disabled={!p.uri}
            onClick={(): void => setPlaylistId(p.id)}
          >
            <ListGroupItemHeading>
              {p.title}&nbsp;
              <ForwardIcon />
            </ListGroupItemHeading>
            <SongsSelected event={props.event} playlist={p} />
          </ListGroupItem>
        ))}
      </ListGroup>
      {props.children}
    </React.Fragment>
  ) : (
    <React.Fragment>
      <BackButton
        onClick={(): void => setPlaylistId(undefined)}
        value="Back To Playlists"
      />
      <PlaylistView playlist={playlist}>
        {playlist.uri && (
          <ActionsWrapper>
            <Button color="primary" tag="a" href={playlist.uri} target="_new">
              Open Playlist in&nbsp;
              {getMusicServiceName(props.event.musicService)}
            </Button>
          </ActionsWrapper>
        )}
      </PlaylistView>
      <ActionsWrapper>
        <Button onClick={nextPlaylist}>Next Playlist</Button>
      </ActionsWrapper>
    </React.Fragment>
  );
};

export default EventPlaylists;
